<template>
  <div class="waffenrecht">
    <header>
      <div class="header-container">
        <div class="image">
          <img
            src="../../src/assets/praxis-lambrette-waffenrecht.png"
            alt="Bild Gutachten im Waffenrecht"
          />
        </div>
        <div class="text">
          <h1>Gutachten im Waffenrecht</h1>
          <p>
            Ich bin zur Begutachtung nach §6 Waffengesetzt vom Bund deutscher
            Psychologinnen und Psychologen
            <a
              href="https://www.psychologenportal.de/waffen/search"
              target="_blank"
              >akkreditiert</a
            >. Ich erstelle zeitnah Gutachten sowohl, wenn dies aufgrund des
            Alters (unter 25) notwendig ist als auch, wenn Zweifel an der
            persönlichen Eignung zur Führung einer Waffe bestehen. Bitte
            <a href="mailto:info@praxis-lambrette.de">kontaktieren</a> Sie mich
            mich für einen ersten Termin.
          </p>
        </div>
      </div>
    </header>

    <Contact></Contact>
  </div>
</template>

<script>
import Contact from "../components/Contact.vue";

export default {
  components: {
    Contact
  },
  metaInfo: {
    title: "Gutachten im Waffenrecht – Dipl.-Psych. Katrin Lambrette",
    meta: [
      {
        name: "description",
        content:
          "Gutachten im Waffenrecht – Ich bin zur Begutachtung nach §6 Waffengesetzt vom Bund deutscher Psychologinnen und Psychologen akkreditiert. Ich erstelle zeitnah Gutachten sowohl, wenn dies aufgrund des Alters (unter 25) notwendig ist als auch, wenn Zweifel an der persönlichen Eignung zur Führung einer Waffen bestehen."
      }
    ],
    htmlAttrs: {
      lang: "de",
      amp: true
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  color: $waffenrecht-color;
}

header {
  @media screen and (min-width: 992px) {
    .header-container {
      .text {
        background-image: url(../../src/assets/praxis-lambrette-waffenrecht-signet-transparent.png);
        background-position: bottom right;
        padding: 0% 10% 0 0;
      }
    }
  }

  @media screen and (min-width: 1200px) {
    .header-container .text {
      padding: 5% 15% 0 0;
    }
  }
}
</style>
